import { useTranslation } from "@/plugins/i18next/i18next";
export function useProductCodenameHelpers() {
    const { t } = useTranslation();
    function productCodenameToName(codename) {
        return t("common:product.codename." + codename);
    }
    function productSystemTagToName(systemTags) {
        return t("people:ShoppingBasket.payableSection.productSystemTag." + systemTags[0]);
    }
    return {
        productCodenameToName,
        productSystemTagToName
    };
}
